import { DatePipe } from '@angular/common';
import { Component, HostListener, OnInit, ViewEncapsulation } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiService } from 'src/app/shared/services';

@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.less'],
  providers: [DatePipe],
  encapsulation: ViewEncapsulation.None
})
export class PartnersComponent implements OnInit {

  tierList = ['Gold', 'Silver', 'Bronze+', 'Bronze'];
  searchValue: string = '';
  tierValue: string[] = [];
  partnersList: any[] = [];
  innerWidth: number;
  originalList: any[] = [];
  noMsg = ''
  isLoading: boolean;

  constructor(
    private api: ApiService,
    private snackbar: MatSnackBar
  ) {
    this.innerWidth = window.innerWidth;
  }

  ngOnInit() {

    this.getPartnersList();
  }

  applyFilters(): void {
    this.noMsg = ''; // reset

    const search = this.searchValue?.trim().toLowerCase() || '';
    const tiers = this.tierValue;

    this.partnersList = this.originalList.filter(item => {
      // Match search text in specified fields
      const matchesSearch = search
        ? ['name', 'url', 'partner_tier', 'catalog_status'].some(
          key => item[key]?.toLowerCase().includes(search)
        )
        : true;

      // Match selected tiers
      const matchesTier = tiers && tiers.length > 0
        ? tiers.includes(item.partner_tier)
        : true;

      // Include only if both match
      return matchesSearch && matchesTier;
    });

    // ✅ Show message if no matches found
    if (this.partnersList.length === 0) {
      this.noMsg = 'No Partners Found';
    }
  }



  getPartnersList() {
    this.isLoading = true;
    this.api.getPartnersList().subscribe((res: any) => {
      if (res && res.length > 0) {
        this.originalList = JSON.parse(JSON.stringify(res));
        this.partnersList = res;
        this.isLoading = false;

      } else {
        this.noMsg = 'No Partners Found';
        this.isLoading = false;

      }
    }, err => {
      this.noMsg = 'No Partners Found';
      this.isLoading = false;


    })

  }

  @HostListener("window:resize")
  onResize() {
    this.innerWidth = this.api.isAdminSidePanelOpened ? window.innerWidth : window.innerWidth + 225;

  }

  panelStateChange() {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 0);
  }

  getColor(status: string) {
    if (status.toUpperCase() == "GOLD") {
      return {
        "background-color": "#ffd704",
        color: "black",
        height: "22px",
        "border-radius": "8px",
      };
    } else if (status.toUpperCase() == "SILVER") {
      return {
        "background-color": "#d6d6d6",
        color: "black",
        height: "22px",
        "border-radius": "8px",
      };
    } else if (status.toUpperCase() == "BRONZE+") {
      return {
        "background-color": "#cd7f31",
        color: "white",
        height: "22px",
        "border-radius": "8px",
      };
    } else if (status.toUpperCase() == "BRONZE") {
      return {
        "background-color": "#8c6239",
        color: "white",
        height: "22px",
        "border-radius": "8px",
      };
    }
  }
  openUrl(url){
    window.open(url,'_blank')
  }

} 